<template>
  <div class="learner-links-list">
    <div v-if="links.length === 0" class="learner-links-empty">
      <span>No links found for this learner. Add a link to get started.</span>
    </div>
    <template v-else>
      <learner-links-item
        v-for="link in paginatedLinks"
        :key="link.id"
        :link="link"
        :can-manage="canManage"
        @edit="onEdit"
        @delete="onDelete"
      />
      <pagination
        v-if="numOfPages > 1"
        v-model="currentPage"
        class="learner-links-pagination"
        :count="numOfPages"
        :total-entries="links.length"
        :displayed-entries="paginatedLinks.length"
        entries-label="links"
      />
    </template>
  </div>
</template>

<style scoped>
.learner-links-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.learner-links-empty {
  color: var(--kate-type-light);
  text-align: center;
  padding: 16px 0;
}

.learner-links-list :deep(.learner-links-pagination .thread-count) {
  font-size: 0.85em;
}
</style>

<script>
import Pagination from '@base-components/k-pagination.vue';
import LearnerLinksItem from './learner-links-item.vue';

const DEFAULT_PAGE_SIZE = 5;

export default {
  components: {
    Pagination,
    LearnerLinksItem,
  },

  props: {
    links: {
      type: Array,
      default: () => [],
    },
    canManage: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      default: DEFAULT_PAGE_SIZE,
    },
  },

  emits: ['edit', 'delete'],

  data() {
    return {
      currentPage: 0,
    };
  },

  watch: {
    links() {
      this.currentPage = 0;
    },
  },

  computed: {
    numOfPages() {
      return Math.ceil(this.links.length / this.pageSize);
    },

    paginatedLinks() {
      const start = this.currentPage * this.pageSize;
      return this.links.slice(start, start + this.pageSize);
    },
  },

  methods: {
    onEdit(link) {
      this.$emit('edit', link);
    },

    onDelete(link) {
      this.$emit('delete', link);
    },
  },
};
</script>
